import {
    extractProperties,
    isEmpty,
} from '.'
import {CaseReducer} from '@reduxjs/toolkit'
import {NinchatState} from 'api/types'
import {NinchatTagCreatedEvent} from '../types/events'

export const tagCreated: CaseReducer<NinchatState> = (state, action) => {
    const {
        realm_id,
        tag_id,
        tag_attrs,
        ...rest
    } = extractProperties<NinchatTagCreatedEvent>(action.payload)

    isEmpty(rest)

    if (realm_id) {
        const {parent_id} = tag_attrs

        if (parent_id) {
            state._tags[realm_id][parent_id].tag_children[tag_id] = {
                tag_attrs,
                tag_children: {},
            }
        } else {
            state._tags[realm_id][tag_id] = {
                tag_attrs,
                tag_children: {},
            }
        }
    }
}
